import {
  SearchableDropdown as EnturSearchableDropdown,
  SearchableDropdownProps as EnturSearchableDropdownProps,
  NormalizedDropdownItemType,
} from '@entur/dropdown';
import { InfoIconWrapper } from 'components/InfoIconWrapper';

export interface SearchableDropdownProps<Valuetype> extends Omit<
  EnturSearchableDropdownProps<Valuetype>,
  'items' | 'selectedItem' | 'onChange'
> {
  value?: Valuetype | null;
  onChange?: (value: Valuetype | null) => void;
  onClick?: () => void;
  items: NormalizedDropdownItemType<Valuetype>[];
  required?: boolean;
  copiedSelectedItem?: NormalizedDropdownItemType<Valuetype> | null;
}

export const SearchableDropdown = <Valuetype,>({
  disableLabelAnimation = true,
  selectOnTab = true,
  readOnly = false,
  loading = false,
  required = false,
  copiedSelectedItem,
  label,
  value,
  items,
  onChange,
  onClick,
  variant,
  feedback,
  ...rest
}: SearchableDropdownProps<Valuetype>) => {
  const selectedItem = items.find((item) => item.value === value) ?? copiedSelectedItem ?? null;

  return (
    <InfoIconWrapper openDrawer={onClick} showIcon={!!value && !!onClick}>
      <EnturSearchableDropdown
        className={required ? 'required' : undefined}
        clearable={!required}
        disableLabelAnimation={disableLabelAnimation}
        selectOnTab={selectOnTab}
        label={label}
        selectedItem={selectedItem}
        items={items}
        onChange={(selected) => {
          const selectedValue = selected?.value ?? null;
          onChange?.(selectedValue);
        }}
        variant={variant}
        feedback={feedback}
        readOnly={readOnly}
        loading={loading}
        {...rest}
      />
    </InfoIconWrapper>
  );
};
